import { createBookingCommentAPI } from "../../../app/api/createBookingCommentAPI";
import { updateBookingCommentAPI } from "../../../app/api/updateBookingCommentAPI";
import { BaseAction } from "../../../core/actions/BaseAction";
import { IBookingComment } from "../../../Orchestrator/Types/Index";
import { ICreateOrUpdateBookingActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/CreateOrUpdateBookingCommentActionParams";

class CreateOrUpdateBookingCommentAction extends BaseAction<IBookingComment | null, ICreateOrUpdateBookingActionParams> {
  override async run(): Promise<IBookingComment | null> {
    try {
      let updatedComment: IBookingComment | null = null

      const { bookingId, commentId, comment } = this.params!;

      if (commentId) {
        let data = await updateBookingCommentAPI(bookingId, commentId, comment);
        if (data.answer) {
          updatedComment = data.answer
        }
      } else {
        let data = await createBookingCommentAPI(bookingId, comment);
        if (data.answer) {
          updatedComment = data.answer
        }
      }

      return updatedComment
    } catch (error) {
      console.error("Error in AddBookingCommentAction:", error);
      throw error;
    }
  }
}

export const createOrUpdateBookingCommentAction = new CreateOrUpdateBookingCommentAction();
